import * as Yup from "yup";

export const loginValidationSchema = Yup.object({
  first_name: Yup.string().required("Obavezno polje"),
  last_name: Yup.string().required("Obavezno polje"),
  password: Yup.string().required("Obavezno polje"),
});
